import React from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <div
      style={{
        border: "2px solid black ",
        backgroundColor: "gray",
        display: "flex",
        justifyContent: "space-around",
        color: "white",
        height: "40px",
      }}
    >
      <Link to={"/signin"}>Sign in </Link>
      <Link to={"/board"}>Kanban Board</Link>
    </div>
  );
}
